import { DraftOrg } from '@espoon-voltti/nuora-domain/applicants'

import {
  DraftNuoraOrgDto,
  NuoraOrgDto,
  OrgDto
} from '@espoon-voltti/nuora-app-common/services/dtos'

export interface DraftApplicantDto {
  org: DraftOrg
  nuoraOrg: DraftNuoraOrgDto
}

export interface ApplicantDto {
  org: OrgDto
  nuoraOrg: NuoraOrgDto
}

export const applicant = {
  org: OrgDto,
  nuoraOrg: NuoraOrgDto
}
